// code_import values returned by mayordomo's diffusion express import (only the ones the front reasons about)
export enum EDiffusionExpressCode {
  HEADER_OK = 0,
  // invited (normal mode) or created (override locker users), see the row detail
  NEW_EMAIL = 101,
  UPDATED = 102,
  NOT_MODIFIED = 103,
  RESTORED = 106,
  WOULD_RESTORE = 107,
  DEACTIVATED = 150,
  WOULD_DEACTIVATE = 151,
  NOT_DEACTIVATED_ACTIVE_ORDERS = 152,
  DEACTIVATION_FAILED = 153,
  VALID_LINE = 160,
  RESIDENT_LINE = 161,
}
